// src/features/resource/resourceActions.js
import { createAction } from '@reduxjs/toolkit';
import { getResources, getResourceDetails, getResourceCategory, getResourceYears } from '../../services/resourceService';

// Action Creators
export const clearMessages = createAction('resource/clearMessages');

// Get Resource Categories
export const getResourceCategoryStart = createAction('resource/getResourceCategoryStart');
export const getResourceCategorySuccess = createAction('resource/getResourceCategorySuccess');
export const getResourceCategoryFailure = createAction('resource/getResourceCategoryFailure');

// Get Resources
export const getResourcesStart = createAction('resource/getResourcesStart');
export const getResourcesSuccess = createAction('resource/getResourcesSuccess');
export const getResourcesFailure = createAction('resource/getResourcesFailure');

// Get Resource Details
export const getResourceDetailsStart = createAction('resource/getResourceDetailsStart');
export const getResourceDetailsSuccess = createAction('resource/getResourceDetailsSuccess');
export const getResourceDetailsFailure = createAction('resource/getResourceDetailsFailure');

// Get Resource Years
export const getResourceYearsStart = createAction('resource/getResourceYearsStart');
export const getResourceYearsSuccess = createAction('resource/getResourceYearsSuccess');
export const getResourceYearsFailure = createAction('resource/getResourceYearsFailure');

// Thunks
export const fetchResourceCategory = (reqData) => async (dispatch) => {
    dispatch(getResourceCategoryStart());
    try {
        const response = await getResourceCategory(reqData);
        if(response.data.status === false){
            dispatch(getResourceCategoryFailure(response.data));
        }else{
            dispatch(getResourceCategorySuccess(response.data));
        }
    } catch (error) {
        dispatch(getResourceCategoryFailure(error.message));
    }
};

export const fetchResources = (resourceData) => async (dispatch) => {
    dispatch(getResourcesStart());
    try {
        const response = await getResources(resourceData);
        if(response.data.status === false){
            dispatch(getResourcesFailure(response.data));
        }else{
            dispatch(getResourcesSuccess(response.data));
        }
    } catch (error) {
        dispatch(getResourcesFailure(error.message));
    }
};

export const fetchResourceDetails = (slug) => async (dispatch) => {
    dispatch(getResourceDetailsStart());
    try {
        const response = await getResourceDetails(slug);
        if(response.data.status === false){
            dispatch(getResourceDetailsFailure(response.data));
        }else{
            dispatch(getResourceDetailsSuccess(response.data));
        }
    } catch (error) {
        dispatch(getResourceDetailsFailure(error.message));
    }
};

// Fetch Resource Years
export const fetchResourceYears = () => async (dispatch) => {
    dispatch(getResourceYearsStart());
    try {
        const response = await getResourceYears();
        if(response.data.status === false){
            dispatch(getResourceYearsFailure(response.data));
        }else{
            dispatch(getResourceYearsSuccess(response.data));
        }
    } catch (error) {
        dispatch(getResourceYearsFailure(error.message));
    }
};
